import { render, staticRenderFns } from "./EdEhrOrgFooter.vue?vue&type=template&id=44be0020&scoped=true&lang=pug"
import script from "./EdEhrOrgFooter.vue?vue&type=script&lang=js"
export * from "./EdEhrOrgFooter.vue?vue&type=script&lang=js"
import style0 from "./EdEhrOrgFooter.vue?vue&type=style&index=0&id=44be0020&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44be0020",
  null
  
)

export default component.exports